import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts"

import { Loader } from "@productlane/ui"

import { api } from "@/lib/api"

export function ApiRequestsChart() {
	const query = api.apiAnalytics.adminRequestSeries.useQuery({ days: 14 })

	return (
		<div className="rounded-lg border p-4">
			<h3 className="mb-3 text-sm font-medium text-gray-800 dark:text-white">
				API requests (last 14 days)
			</h3>
			<div className="h-64">
				{query.data && !query.isLoading ? (
					<ResponsiveContainer width="100%" height="100%">
						<BarChart data={query.data} maxBarSize={12}>
							<CartesianGrid className="stroke-gray-200 dark:stroke-gray-700" />
							<XAxis dataKey="day" tick={{ fontSize: 10 }} />
							<YAxis tick={{ fontSize: 10 }} />
							<Tooltip />
							<Legend wrapperStyle={{ fontSize: 12 }} />
							<Bar
								dataKey="successful"
								name="Successful"
								stackId="a"
								fill="#22c55e"
							/>
							<Bar dataKey="failed" name="Failed" stackId="a" fill="#ef4444" />
						</BarChart>
					</ResponsiveContainer>
				) : (
					<div className="flex h-full items-center justify-center">
						<Loader />
					</div>
				)}
			</div>
		</div>
	)
}
